import {CompanyStructureDepartment, CompanyStructureForPlanningResponse} from "@/types/service-response";

export class Department {
  private constructor(
    readonly id: number, // ID
    readonly profitCenterId: number, // ProfitCenterID
    readonly code: string, // Code
    readonly approachIntern: number, // AnsatzIntern
    readonly approachExtern: number, // AnsatzExtern
    readonly costCenter: number, // Kostenstelle
    readonly overheads: number, // Gemeinkosten
    readonly ABID: number, // ABID
    readonly label: string, // Bezeichnung
    readonly PCABTLabel: string // PCABTLabel
  ) {
  }

  static createFromResponse(responseData: CompanyStructureForPlanningResponse): Array<Department> {
    let result: Array<Department> = []
    if (responseData.abteilungens) {
      result = responseData.abteilungens.map((department: CompanyStructureDepartment) => {
        return new Department(
          department.ID,
          department.ProfitCenterID,
          department.Code,
          department.AnsatzIntern,
          department.AnsatzExtern,
          department.Kostenstelle,
          department.Gemeinkosten,
          department.ABID,
          department.Bezeichnung,
          department.PCABTLabel
        )
      })
    }
    return result
  }
}